import React, { memo, useEffect } from 'react'
import TagManager from 'react-gtm-module'

const Analytics = () => {
  useEffect(() => {
    TagManager.initialize({ gtmId: process.env.NEXT_PUBLIC_GTM_2_ID })
  }, [])

  return (
    <>

    </>
  )
}

export default memo(Analytics)
